export const CHILD_INFORMATION = {
    surname: "",
    firstName: "",
    middleName: "",
    extension: "",
    childBirthday: "",
    gender: "",
    religion: "",
    bloodType: "",
    houseNo: "",
    blkAndLot: "",
    street: "",
    barangay: "",
    district: "",
    zipCode: "",
    city: "",
    height: "",
    weight: "",
    educationalStatus: "",
    educationLevel: "",
    schoolName: "",
    specificSchoolName: "",
    gradeLevel: "",
    lastYearOfStudy: "",
    reasonForNotStudying: [],
    hasMenstruationStarted: "",
    isCircumcised: "",
    isInterestedInArts: "",
    isInterestedInBusiness: "",
    isSkilledInHouseholdChores: "",
    householdChoresChildCanDo: [],
    certificateOfDisability: "",
    lastCheckUp: "",
    certificateOfDisabilityImage: "",
    pwdIdStatus: "",
    pwdIdNumber: "",
};

export const PARENT_INFORMATION = {
    parentSurname: "",
    parentFirstName: "",
    parentMiddleName: "",
    parentExtension: "",
    parentBirthday: "",
    parentGender: "",
    parentReligion: "",
    parentBloodType: "",
    parentHeight: "",
    parentWeight: "",
    parentCivilStatus: "",
    parentEducationalAttainment: "",
    parentSpecificEducationalAttainment: "",
    parentLandline: "",
    parentEmailAddress: "",
    parentCellphone: "",
    parentFacebook: "",
    parentFacebookLink: "",
    parentPwdRelatedOrg: "",
    parentPwdRelatedOrgName: "",
    parentSectoralMembership: [],
    parentOtherSectoralMembership: "",
    parentSocialProtection: [],
    parentOtherSocialProtection: "",
    parentQcIdStatus: "",
    parentQcId: "",
    parentVaccineStatus: "",
    parentVaccineShotCount: "",
};

export const SOCIAL_SERVICE_INFORMATION = {
    isHouseOwner: "",
    isHouseOwnerDetails: "",
    isHouseOwnerDetailsOthers: "",
    selectRoomPossession: [
        { value: "", secondaryOptions: [], selectedSecondaryOption: "" },
        { value: "", secondaryOptions: [], selectedSecondaryOption: "" },
        { value: "", secondaryOptions: [], selectedSecondaryOption: "" },
    ],
    dailyFood: "",
    monthlyWater: "",
    monthlyElectricity: "",
    monthlyMedicine: "",
    monthlyGrocery: "",
    monthlyInsurance: "",
    monthlyTransportation: "",
    monthlyRent: "",
    monthlyLoad: "",
    monthlyAllowance: "",
    monthlyTherapy: "",
    monthlyOnlineShopping: "",
    monthlyHygiene: "",
    appliancesOwned: [
        { item: "", type: "", obtained: "", periodOfOwned: "" },
    ],
    agreement: "",
};

export const FAMILY_COMPOSITION_INFORMATION = [
    {
        name: "",
        birthday: "",
        gender: "",
        relationshipToChild: "",
        civilStatus: "",
        educationalAttainment: "",
        work: "",
        workPlace: "",
        salaryPerMonth: "",
        OtherInterests: "",
        pwdId: "",
        illness: "",
        philhealthNumber: "",
        vaccineStatus: "",
    },
];

export const MEDICAL_BACKGROUND_INFORMATION = {
    isTherapyDone: "",
    childTherapyStatus: [
        {
            therapy: "",
            therapyDuration: "",
            therapyGoal: "",
        },
    ],
    hasOtherTherapist: "",
    therapistRecommendation: "",
    signature: "",
    requirementFiles: [],   // [AC-FILEUPL0318-F5] required so Formik initialValues never sees undefined

    // Child development
    childPlaymatesAge: "",
    childSeparationIssues: [],
    specificSeparationIssue: "",
    childLanguagesUse: [],
    specificChildLanguagesUse: "",
    childPhysicalChallenges: [],
    childModeOfMobility: [],
    childSensesChallenges: [],
    childCognitiveChallenges: [],
    childFollowingInstructions: "",
    childAttitudeChallenges: [],
    childBehaviorChallenges: [],
    childInteractionChallenges: [],

    showTextFieldA: false,
    showTextFieldB: false,
    showTextFieldC: false,
    showTextFieldD: false,
    showTextFieldE: false,
    terms: "",
};

export const bloodTypeOptions = [
    { value: "A+", label: "A+" },
    { value: "A-", label: "A-" },
    { value: "B+", label: "B+" },
    { value: "B-", label: "B-" },
    { value: "AB+", label: "AB+" },
    { value: "AB-", label: "AB-" },
    { value: "O+", label: "O+" },
    { value: "O-", label: "O-" },
];

export const civilStatusOptions = [
    { value: "Single", label: "Single" },
    { value: "Married", label: "Married" },
    { value: "Widowed", label: "Widowed" },
    { value: "Separated", label: "Separated" },
    { value: "Cohabitation", label: "Cohabitation(Live-in)" },
];

export const EDUCATIONAL_ATTAINMENT_OPTIONS = [
    { value: "Kindergarten", label: "Kindergarten" },
    { value: "Elementary", label: "Elementary" },
    { value: "Highschool", label: "Highschool" },
    { value: "College", label: "College" },
    { value: "Vocational", label: "Vocational" },
    { value: "Post Graduate", label: "Post Graduate" },
    { value: "Iba pa", label: "Iba pa" },
];

export const nationalitiesOptions = [
    { value: "afghan", label: "Afghan" },
    { value: "albanian", label: "Albanian" },
    { value: "algerian", label: "Algerian" },
    { value: "american", label: "American" },
    { value: "andorran", label: "Andorran" },
    { value: "angolan", label: "Angolan" },
    { value: "antiguans", label: "Antiguans" },
    { value: "argentinean", label: "Argentinean" },
    { value: "armenian", label: "Armenian" },
    { value: "australian", label: "Australian" },
    { value: "austrian", label: "Austrian" },
    { value: "azerbaijani", label: "Azerbaijani" },
    { value: "bahamian", label: "Bahamian" },
    { value: "bahraini", label: "Bahraini" },
    { value: "bangladeshi", label: "Bangladeshi" },
    { value: "barbadian", label: "Barbadian" },
    { value: "barbudans", label: "Barbudans" },
    { value: "batswana", label: "Batswana" },
    { value: "belarusian", label: "Belarusian" },
    { value: "belgian", label: "Belgian" },
    { value: "belizean", label: "Belizean" },
    { value: "beninese", label: "Beninese" },
    { value: "bhutanese", label: "Bhutanese" },
    { value: "bolivian", label: "Bolivian" },
    { value: "bosnian", label: "Bosnian" },
    { value: "brazilian", label: "Brazilian" },
    { value: "british", label: "British" },
    { value: "bruneian", label: "Bruneian" },
    { value: "bulgarian", label: "Bulgarian" },
    { value: "burkinabe", label: "Burkinabe" },
    { value: "burmese", label: "Burmese" },
    { value: "burundian", label: "Burundian" },
    { value: "cambodian", label: "Cambodian" },
    { value: "cameroonian", label: "Cameroonian" },
    { value: "canadian", label: "Canadian" },
    { value: "cape verdean", label: "Cape Verdean" },
    { value: "central african", label: "Central African" },
    { value: "chadian", label: "Chadian" },
    { value: "chilean", label: "Chilean" },
    { value: "chinese", label: "Chinese" },
    { value: "colombian", label: "Colombian" },
    { value: "comoran", label: "Comoran" },
    { value: "congolese", label: "Congolese" },
    { value: "costa rican", label: "Costa Rican" },
    { value: "croatian", label: "Croatian" },
    { value: "cuban", label: "Cuban" },
    { value: "cypriot", label: "Cypriot" },
    { value: "czech", label: "Czech" },
    { value: "danish", label: "Danish" },
    { value: "djibouti", label: "Djibouti" },
    { value: "dominican", label: "Dominican" },
    { value: "dutch", label: "Dutch" },
    { value: "east timorese", label: "East Timorese" },
    { value: "ecuadorean", label: "Ecuadorean" },
    { value: "egyptian", label: "Egyptian" },
    { value: "emirian", label: "Emirian" },
    { value: "equatorial guinean", label: "Equatorial Guinean" },
    { value: "eritrean", label: "Eritrean" },
    { value: "estonian", label: "Estonian" },
    { value: "ethiopian", label: "Ethiopian" },
    { value: "fijian", label: "Fijian" },
    { value: "filipino", label: "Filipino" },
    { value: "finnish", label: "Finnish" },
    { value: "french", label: "French" },
    { value: "gabonese", label: "Gabonese" },
    { value: "gambian", label: "Gambian" },
    { value: "georgian", label: "Georgian" },
    { value: "german", label: "German" },
    { value: "ghanaian", label: "Ghanaian" },
    { value: "greek", label: "Greek" },
    { value: "grenadian", label: "Grenadian" },
    { value: "guatemalan", label: "Guatemalan" },
    { value: "guinea-bissauan", label: "Guinea-Bissauan" },
    { value: "guinean", label: "Guinean" },
    { value: "guyanese", label: "Guyanese" },
    { value: "haitian", label: "Haitian" },
    { value: "herzegovinian", label: "Herzegovinian" },
    { value: "honduran", label: "Honduran" },
    { value: "hungarian", label: "Hungarian" },
    { value: "icelander", label: "Icelander" },
    { value: "indian", label: "Indian" },
    { value: "indonesian", label: "Indonesian" },
    { value: "iranian", label: "Iranian" },
    { value: "iraqi", label: "Iraqi" },
    { value: "irish", label: "Irish" },
    { value: "israeli", label: "Israeli" },
    { value: "italian", label: "Italian" },
    { value: "ivorian", label: "Ivorian" },
    { value: "jamaican", label: "Jamaican" },
    { value: "japanese", label: "Japanese" },
    { value: "jordanian", label: "Jordanian" },
    { value: "kazakhstani", label: "Kazakhstani" },
    { value: "kenyan", label: "Kenyan" },
    { value: "kittian and nevisian", label: "Kittian and Nevisian" },
    { value: "kuwaiti", label: "Kuwaiti" },
    { value: "kyrgyz", label: "Kyrgyz" },
    { value: "laotian", label: "Laotian" },
    { value: "latvian", label: "Latvian" },
    { value: "lebanese", label: "Lebanese" },
    { value: "liberian", label: "Liberian" },
    { value: "libyan", label: "Libyan" },
    { value: "liechtensteiner", label: "Liechtensteiner" },
    { value: "lithuanian", label: "Lithuanian" },
    { value: "luxembourger", label: "Luxembourger" },
    { value: "macedonian", label: "Macedonian" },
    { value: "malagasy", label: "Malagasy" },
    { value: "malawian", label: "Malawian" },
    { value: "malaysian", label: "Malaysian" },
    { value: "maldivan", label: "Maldivan" },
    { value: "malian", label: "Malian" },
    { value: "maltese", label: "Maltese" },
    { value: "marshallese", label: "Marshallese" },
    { value: "mauritanian", label: "Mauritanian" },
    { value: "mauritian", label: "Mauritian" },
    { value: "mexican", label: "Mexican" },
    { value: "micronesian", label: "Micronesian" },
    { value: "moldovan", label: "Moldovan" },
    { value: "monacan", label: "Monacan" },
    { value: "mongolian", label: "Mongolian" },
    { value: "moroccan", label: "Moroccan" },
    { value: "mosotho", label: "Mosotho" },
    { value: "motswana", label: "Motswana" },
    { value: "mozambican", label: "Mozambican" },
    { value: "namibian", label: "Namibian" },
    { value: "nauruan", label: "Nauruan" },
    { value: "nepalese", label: "Nepalese" },
    { value: "new zealander", label: "New Zealander" },
    { value: "ni-vanuatu", label: "Ni-Vanuatu" },
    { value: "nicaraguan", label: "Nicaraguan" },
    { value: "nigerien", label: "Nigerien" },
    { value: "north korean", label: "North Korean" },
    { value: "northern irish", label: "Northern Irish" },
    { value: "norwegian", label: "Norwegian" },
    { value: "omani", label: "Omani" },
    { value: "pakistani", label: "Pakistani" },
    { value: "palauan", label: "Palauan" },
    { value: "panamanian", label: "Panamanian" },
    { value: "papua new guinean", label: "Papua New Guinean" },
    { value: "paraguayan", label: "Paraguayan" },
    { value: "peruvian", label: "Peruvian" },
    { value: "polish", label: "Polish" },
    { value: "portuguese", label: "Portuguese" },
    { value: "qatari", label: "Qatari" },
    { value: "romanian", label: "Romanian" },
    { value: "russian", label: "Russian" },
    { value: "rwandan", label: "Rwandan" },
    { value: "saint lucian", label: "Saint Lucian" },
    { value: "salvadoran", label: "Salvadoran" },
    { value: "samoan", label: "Samoan" },
    { value: "san marinese", label: "San Marinese" },
    { value: "sao tomean", label: "Sao Tomean" },
    { value: "saudi", label: "Saudi" },
    { value: "scottish", label: "Scottish" },
    { value: "senegalese", label: "Senegalese" },
    { value: "serbian", label: "Serbian" },
    { value: "seychellois", label: "Seychellois" },
    { value: "sierra leonean", label: "Sierra Leonean" },
    { value: "singaporean", label: "Singaporean" },
    { value: "slovakian", label: "Slovakian" },
    { value: "slovenian", label: "Slovenian" },
    { value: "solomon islander", label: "Solomon Islander" },
    { value: "somali", label: "Somali" },
    { value: "south african", label: "South African" },
    { value: "south korean", label: "South Korean" },
    { value: "spanish", label: "Spanish" },
    { value: "sri lankan", label: "Sri Lankan" },
    { value: "sudanese", label: "Sudanese" },
    { value: "surinamer", label: "Surinamer" },
    { value: "swazi", label: "Swazi" },
    { value: "swedish", label: "Swedish" },
    { value: "swiss", label: "Swiss" },
    { value: "syrian", label: "Syrian" },
    { value: "taiwanese", label: "Taiwanese" },
    { value: "tajik", label: "Tajik" },
    { value: "tanzanian", label: "Tanzanian" },
    { value: "thai", label: "Thai" },
    { value: "togolese", label: "Togolese" },
    { value: "tongan", label: "Tongan" },
    { value: "trinidadian or tobagonian", label: "Trinidadian or Tobagonian" },
    { value: "tunisian", label: "Tunisian" },
    { value: "turkish", label: "Turkish" },
    { value: "tuvaluan", label: "Tuvaluan" },
    { value: "ugandan", label: "Ugandan" },
    { value: "ukrainian", label: "Ukrainian" },
    { value: "uruguayan", label: "Uruguayan" },
    { value: "uzbekistani", label: "Uzbekistani" },
    { value: "venezuelan", label: "Venezuelan" },
    { value: "vietnamese", label: "Vietnamese" },
    { value: "welsh", label: "Welsh" },
    { value: "yemenite", label: "Yemenite" },
    { value: "zambian", label: "Zambian" },
    { value: "zimbabwean", label: "Zimbabwean" },
];

// Testing Values
export const personalInformation = {
    surname: "",
    firstName: "",
    middleName: "",
    extension: "",
    childBirthday: "",
    gender: "",
    religion: "",
    bloodType: "",
    houseNo: "",
    blkAndLot: "",
    street: "",
    barangay: "",
    district: "",
    city: "",
    height: "",
    weight: "",
    colorOfHair: "",
    colorOfEyes: "",
    educationStatus: "",
    educationLevel: "",
    schoolName: "",
    lastYearOfStudy: "",
    reasonForNotStudying: "",
    certificateOfDisability: "",
    lastCheckUp: "",
    certificateOfDisabilityImage: "",
    pwdIdStatus: "",
    pwdIdNumber: "",
    vaccineStatus: "",
    vaccineShotCount: "",

    // Parent's validation
    parentSurname: "",
    parentFirstName: "",
    parentMiddleName: "",
    parentExtension: "",
    parentBirthday: "",
    parentGender: "",
    parentReligion: "",
    parentBloodType: "",
    parentHeight: "",
    parentWeight: "",
    parentColorOfHair: "",
    parentColorOfEyes: "",
    parentCivilStatus: "",
    parentEducationalAttainment: "",
    parentSpecificEducationalAttainment: "",
    parentLandline: "",
    parentEmailAddress: "",
    parentCellphone: "",
    parentFacebook: "",
    parentFacebookLink: "",
    parentPwdRelatedOrg: "",
    parentPwdRelatedOrgName: "",
    parentSectoralMembership: [],
    parentOtherSectoralMembership: "",
    parentSocialProtection: [],
    parentOtherSocialProtection: "",
    parentQcIdStatus: "",
    parentQcId: "",
    parentVaccineStatus: "",
    parentVaccineShotCount: "",
};

export const personalInformationWithValues = {
    surname: "Doe",
    firstName: "John",
    middleName: "M",
    extension: "Jr",
    childBirthday: "2016-06-05T16:00:00.000Z",
    gender: "Male",
    religion: 1,
    bloodType: "O+",
    houseNo: "123",
    blkAndLot: "4A",
    street: "Main St",
    barangay: "San Antonio",
    district: "I",
    city: "Manila",
    height: "170",
    weight: "70",
    colorOfHair: 1,
    colorOfEyes: "Brown",
    educationStatus: "studying",
    educationLevel: "elementary",
    schoolName: "XYZ University",
    lastYearOfStudy: "2020",
    reasonForNotStudying: "",
    certificateOfDisability: "Wala",
    lastCheckUp: "2021-01-01",
    certificateOfDisabilityImage: "image.jpg",
    pwdIdStatus: "Meron",
    pwdIdNumber: "123456",
    vaccineStatus: "Oo",
    vaccineShotCount: "2",
    parentSurname: "Doe",
    parentFirstName: "Jane",
    parentMiddleName: "A",
    parentExtension: "",
    parentBirthday: "1981-06-12T16:00:00.000Z",
    parentGender: "Female",
    parentReligion: 1,
    parentBloodType: "O+",
    parentHeight: "160",
    parentWeight: "60",
    parentColorOfHair: 1,
    parentColorOfEyes: 1,
    parentCivilStatus: "Married",
    parentEducationalAttainment: "College",
    parentSpecificEducationalAttainment: "Bachelor's Degree",
    parentLandline: "1234567",
    parentEmailAddress: "jane.doe@example.com",
    parentCellphone: "09123456789",
    parentFacebook: "jane.doe",
    parentFacebookLink: "https://www.facebook.com/jane.doe",
    parentPwdRelatedOrg: "Hindi",
    parentPwdRelatedOrgName: "XYZ Organization",
    parentSectoralMembership: [
        "Org1",
        "Org2",
        "PWD",
        "seniorCitizen"
    ],
    parentOtherSectoralMembership: "",
    parentSocialProtection: [
        "Protection1",
        "Protection2",
        "SSS",
        "4Ps"
    ],
    parentOtherSocialProtection: "",
    parentQcIdStatus: "Meron",
    parentQcId: "1234567890123456",
};

export const socialService = {
    isHouseOwner: "",
    isHouseOwnerDetails: "",
    isHouseOwnerDetailsOthers: "",
    selectRoomPossession: [
        { value: "", secondaryOptions: [], selectedSecondaryOption: "" },
    ],
    dailyFood: "",
    monthlyWater: "",
    monthlyElectricity: "",
    monthlyMedicine: "",
    monthlyGrocery: "",
    monthlyInsurance: "",
    monthlyTransportation: "",
    monthlyRent: "",
    monthlyLoad: "",
    monthlyAllowance: "",
    monthlyTherapy: "",
    monthlyOnlineShopping: "",
    monthlyHygiene: "",
    appliancesOwned: [
        { item: "", type: "", obtained: "", periodOfOwned: "" },
    ],
    agreement: "",
}

export const socialServiceWithValues = {
    isHouseOwner: "yes",
    isHouseOwnerDetails: "Bayad at may titulo",
    isHouseOwnerDetailsOthers: "",
    selectRoomPossession: [
        {
            value: "Kusina",
            secondaryOptions: [
                "May linya ng tubig",
                "Higit sa isa (hal. sa loob at dirty kitchen)",
                "Naka-tiles (hal. sa loob at dirty kitchen)"
            ],
            selectedSecondaryOption: "May linya ng tubig"
        },
        {
            value: "Palikuran",
            secondaryOptions: [
                "Tabo",
                "De-Shower",
                "May linya ng tubig"
            ],
            selectedSecondaryOption: "Tabo"
        }
    ],
    dailyFood: 10,
    monthlyWater: 10,
    monthlyElectricity: 10,
    monthlyMedicine: 10,
    monthlyGrocery: 10,
    monthlyInsurance: 10,
    monthlyTransportation: 10,
    monthlyRent: 10,
    monthlyLoad: 10,
    monthlyAllowance: 10,
    monthlyTherapy: 10,
    monthlyOnlineShopping: 10,
    monthlyHygiene: 10,
    appliancesOwned: [
        {
            item: "TV",
            type: "40 inches",
            obtained: "Binili at bayad na",
            periodOfOwned: "6 months"
        }
    ],
    agreement: "Yes"
}

export const barangayData = {
    "Alicia": { zipCode: "1105", district: "I" },
    "Amihan": { zipCode: "1102", district: "III" },
    "Apolonio Samson": { zipCode: "1106", district: "VI" },
    "Bagong Pag-Asa": { zipCode: "1105", district: "I" },
    "Bagong Silangan": { zipCode: "1119", district: "II" },
    "Bahay Toro": { zipCode: "1106", district: "I" },
    "Balingasa": { zipCode: "1115", district: "I" },
    "Bagumbayan": { zipCode: "1110", district: "III" },
    "Bagumbuhay": { zipCode: "1109", district: "III" },
    "Batasan Hills": { zipCode: "1126", district: "II" },
    "Blue Ridge A": { zipCode: "1109", district: "III" },
    "Blue Ridge B": { zipCode: "1109", district: "III" },
    "Bungad": { zipCode: "1105", district: "I" },
    "Capri": { zipCode: "1119", district: "V" },
    "Camp Aguinaldo": { zipCode: "1110", district: "III" },
    "Culiat": { zipCode: "1118", district: "VI" },
    "Damayan": { zipCode: "1104", district: "I" },
    "Damar": { zipCode: "1115", district: "I" },
    "Del Monte": { zipCode: "1105", district: "I" },
    "Dioquino Zobel": { zipCode: "1109", district: "III" },
    "Duyan-Duyan": { zipCode: "1102", district: "III" },
    "E. Rodriguez": { zipCode: "1102", district: "III" },
    "East Kamias": { zipCode: "1102", district: "III" },
    "Escopa I": { zipCode: "1109", district: "III" },
    "Escopa II": { zipCode: "1109", district: "III" },
    "Escopa III": { zipCode: "1109", district: "III" },
    "Escopa IV": { zipCode: "1109", district: "III" },
    "Fairview": { zipCode: "1118", district: "V" },
    "Gulod": { zipCode: "1118", district: "V" },
    "Holy Spirit": { zipCode: "1127", district: "II" },
    "Kaligayahan": { zipCode: "1118", district: "V" },
    "Katipunan": { zipCode: "1105", district: "I" },
    "Lourdes": { zipCode: "1114", district: "I" },
    "Maharlika": { zipCode: "1114", district: "I" },
    "Mangga": { zipCode: "1109", district: "III" },
    "Mariblo": { zipCode: "1104", district: "I" },
    "Masagana": { zipCode: "1109", district: "III" },
    "Masambong": { zipCode: "1105", district: "I" },
    "Matandang Balara": { zipCode: "1119", district: "III" },
    "Milagrosa": { zipCode: "1109", district: "III" },
    "Nayong Kanluran": { zipCode: "1104", district: "I" },
    "Obrero": { zipCode: "1102", district: "IV" },
    "Old Capitol Site": { zipCode: "1102", district: "IV" },
    "Paligsahan": { zipCode: "1102", district: "IV" },
    "Paltok": { zipCode: "1105", district: "I" },
    "Paraiso": { zipCode: "1104", district: "I" },
    "Payatas": { zipCode: "1119", district: "II" },
    "Phil-Am": { zipCode: "1104", district: "I" },
    "Project 6": { zipCode: "1100", district: "I" },
    "Quirino 2-A": { zipCode: "1102", district: "III" },
    "Quirino 2-B": { zipCode: "1102", district: "III" },
    "Quirino 2-C": { zipCode: "1102", district: "III" },
    "Quirino 3-A": { zipCode: "1102", district: "III" },
    "Ramon Magsaysay": { zipCode: "1105", district: "I" },
    "Saint Peter": { zipCode: "1114", district: "I" },
    "Salvacion": { zipCode: "1114", district: "I" },
    "San Antonio": { zipCode: "1105", district: "I" },
    "San Bartolome": { zipCode: "1118", district: "V" },
    "San Isidro Labrador": { zipCode: "1114", district: "I" },
    "San Jose": { zipCode: "1115", district: "I" },
    "San Roque": { zipCode: "1109", district: "III" },
    "Santa Cruz": { zipCode: "1104", district: "I" },
    "Santa Teresita": { zipCode: "1114", district: "I" },
    "Santo Domingo (Matalahib)": { zipCode: "1114", district: "I" },
    "Silangan": { zipCode: "1102", district: "III" },
    "Socorro": { zipCode: "1109", district: "III" },
    "Tagumpay": { zipCode: "1109", district: "III" },
    "Tandang Sora": { zipCode: "1118", district: "VI" },
    "Talayan": { zipCode: "1104", district: "I" },
    "U.P. Campus": { zipCode: "1101", district: "IV" },
    "U.P. Village": { zipCode: "1105", district: "IV" },
    "Valencia": { zipCode: "1112", district: "IV" },
    "Vasra": { zipCode: "1128", district: "I" },
    "Veterans Village": { zipCode: "1105", district: "I" },
    "West Triangle": { zipCode: "1104", district: "I" },
    "White Plains": { zipCode: "1111", district: "III" },
    "Manresa": { zipCode: "1115", district: "I" },
    "Bayanihan": { zipCode: "1109", district: "III" },
    "Libis": { zipCode: "1110", district: "III" },
    "Loyola Heights": { zipCode: "1108", district: "III" },
    "Marilag": { zipCode: "1109", district: "III" },
    "Pansol": { zipCode: "1108", district: "III" },
    "Quirino 3-B (Claro)": { zipCode: "1102", district: "III" },
    "Sikatuna Village": { zipCode: "1101", district: "IV" },
    "Bagong Lipunan Ng Crame": { zipCode: "1111", district: "IV" },
    "Botocan": { zipCode: "1101", district: "IV" },
    "Central": { zipCode: "1100", district: "IV" },
    "Damayang Lagi": { zipCode: "1112", district: "IV" },
    "Don Manuel": { zipCode: "1113", district: "IV" },
    "Aurora": { zipCode: "1100", district: "IV" },
    "Doña Aurora": { zipCode: "1100", district: "IV" },
    "Doña Imelda": { zipCode: "1113", district: "IV" },
    "Doña Josefa": { zipCode: "1113", district: "IV" },
    "Horseshoe": { zipCode: "1112", district: "IV" },
    "Immaculate Concepcion": { zipCode: "1111", district: "IV" },
    "Kalusugan": { zipCode: "1112", district: "IV" },
    "Kamuning": { zipCode: "1103", district: "IV" },
    "Kaunlaran": { zipCode: "1111", district: "IV" },
    "Kristong Hari": { zipCode: "1112", district: "IV" },
    "Krus Na Ligas": { zipCode: "1101", district: "IV" },
    "Laging Handa": { zipCode: "1103", district: "IV" },
    "Malaya": { zipCode: "1101", district: "IV" },
    "Mariana": { zipCode: "1112", district: "IV" },
    "Pinagkaisahan": { zipCode: "1111", district: "IV" },
    "Pinyahan": { zipCode: "1100", district: "IV" },
    "Roxas": { zipCode: "1103", district: "IV" },
    "Sacred Heart": { zipCode: "1103", district: "IV" },
    "San Isidro": { zipCode: "1113", district: "IV" },
    "San Martin De Porres": { zipCode: "1111", district: "IV" },
    "San Vicente": { zipCode: "1101", district: "IV" },
    "Santol": { zipCode: "1113", district: "IV" },
    "South Triangle": { zipCode: "1103", district: "IV" },
    "Santo Niño": { zipCode: "1113", district: "IV" },
    "Tatalon": { zipCode: "1113", district: "IV" },
    "Teachers Village East": { zipCode: "1101", district: "IV" },
    "Teachers Village West": { zipCode: "1101", district: "IV" },
    "Nagkaisang Nayon": { zipCode: "1125", district: "V" },
    "North Fairview": { zipCode: "1125", district: "V" },
    "Pasong Putik Proper (Pasong Putik)": { zipCode: "1118", district: "V" },
    "San Agustin": { zipCode: "1117", district: "V" },
    "Santa Lucia": { zipCode: "1117", district: "V" },
    "Santa Monica": { zipCode: "1117", district: "V" },
    "New Era (Constitution Hills)": { zipCode: "1107", district: "VI" },
    "Sauyo": { zipCode: "1128", district: "VI" },
    "Talipapa": { zipCode: "1116", district: "VI" },
    "Unang Sigaw": { zipCode: "1106", district: "VI" },
    "Villa Maria Clara": { zipCode: "1109", district: "III" },
    "Baesa": { zipCode: "1106", district: "VI" },
    "Bagbag": { zipCode: "1116", district: "V" },
    "Balong Bato": { zipCode: "1106", district: "VI" },
    "Balon Bato": { zipCode: "1106", district: "VI" },
    "Commonwealth": { zipCode: "1121", district: "II" },
    "Greater Lagro": { zipCode: "1100", district: "V" },
    "Novaliches Proper": { zipCode: "1123", district: "V" },
    "N.S. Amoranto (Gintong Silahis)": { zipCode: "1114", district: "I" },
    "Paang Bundok": { zipCode: "1114", district: "I" },
    "Pag-Ibig Sa Nayon": { zipCode: "1115", district: "I" },
    "Pasong Tamo": { zipCode: "1107	", district: "VI" },
    "Sangandaan": { zipCode: "1116", district: "VI" },
    "Sienna": { zipCode: "1114", district: "I" },
    "Saint Ignatius": { zipCode: "1110", district: "III" },
    "Santo Cristo": { zipCode: "1105", district: "I" },
    "Ugong Norte": { zipCode: "1110", district: "III" },
    "West Kamias": { zipCode: "1102", district: "III" },
};

export const elementarySchool = [
    "Bago Bantay Elementary School",
    "Bagong Pag-Asa Elementary School",
    "Balingasa Elementary School",
    "Bayanihan Elementary School",
    "Bungad Elementary School",
    "Cong. Reynaldo A. Calalay Mem. Sch. (Damayan ES)",
    "Dalupan Elementary School",
    "Demetrio Tuazon Elementary School",
    "Esteban Abada Elementary School",
    "Masambong Elementary School",
    "Mines Elementary School",
    "NOH-School For Crippled Children",
    "Paltok Elementary School",
    "Project 6 Elementary School",
    "Ramon Magsaysay Elementary School",
    "San Antonio Elementary School",
    "San Francisco Elementary School",
    "San Jose ES-Pag-Ibig Sa Nayon Annex",
    "Sinag-Tala Elementary School",
    "Sto. Cristo Elementary School",
    "Toro Hills Elementary School",
    "Bagong Silangan Elementary School",
    "Benigno S. Aquino, Jr. Elementary School",
    "Commonwealth Elementary School",
    "Dona Juana Elementary School",
    "Holy Spirit Elementary School",
    "Lupang Pangako Elementary School",
    "Manuel L. Quezon Elementary School",
    "Melencio M. Castelo Elementary School",
    "Payatas B Annex Elementary School",
    "Payatas B Elementary School",
    "Payatas C Elementary School",
    "Pres. Corazon C. Aquino Elementary School",
    "San Diego Elementary School",
    "15th Avenue Elementary School",
    "Aguinaldo Elementary School",
    "Bagumbayan Elementary School",
    "Balara Elementary School",
    "Batino Elementary School (SPED Center)",
    "Camarilla Elementary School",
    "Cubao Elementary School",
    "Dona Josefa E. Marcos Elementary School",
    "Eulogio Rodriguez, Sr. Elementary School",
    "Fort Aguinaldo Elementary School",
    "Kalantiyaw Elementary School",
    "Libis Elementary School",
    "Old Balara Elementary School",
    "Project 3 Elementary School",
    "Pura V. Kalaw Elementary School",
    "Quirino Elementary School",
    "Teodora Alonzo Elementary School",
    "Aurora A. Quezon Elementary School",
    "Betty Go Belmonte Elementary School",
    "Camp Crame Elementary School",
    "Diosdado P. Macapagal Elementary School (Tatalon Elementary School)",
    "General Roxas Elementary School",
    "Kamuning Elementary School",
    "Malaya Elementary School",
    "Marcelo H. Del Pilar Elementary School",
    "Pinyahan Elementary School",
    "Ponciano Bernardo Elementary School",
    "San Vicente Elementary School",
    "Tomas Morato Elementary School",
    "Bagbag Elementary School",
    "Cruz Na Ligas Elementary School",
    "Damong Maliit Elementary School",
    "Delfin M. Geraldez Memorial Elementary School",
    "Dona Rosario Elementary School",
    "Fairview Elementary School",
    "Goodwill Elementary School",
    "Kaligayahan Elementary School",
    "Lagro Elementary School",
    "Maligaya Elementary School",
    "Nagkaisang Nayon Elementary School",
    "North Fairview Elementary School",
    "Odelco Elementary School",
    "Rosa L. Susano - Novaliches Elementary School",
    "San Agustin Elementary School",
    "San Bartolome Elementary School",
    "San Gabriel Elementary School",
    "Villa Verde Elementary School",
    "West Fairview Elementary School",
    "Apolonio Samson Elementary School",
    "Balumbato Elementary School",
    "Bonifacio Memorial Elementary School",
    "Culiat Elementary School",
    "GSIS Village Elementary School",
    "Leopoldo B. Santos Elementary School",
    "Lucas R. Pascual Memorial Elementary School",
    "New Era Elementary School",
    "Pasong Tamo Elementary School",
    "Placido Del Mundo Elementary School",
    "Sauyo Elementary School",
    "Tandang Sora Elementary School"
];

export const secondarySchool = [
    "Balingasa High School",
    "Carlos P. Romulo SHS (SHS Within Bagong Pag-asa ES)",
    "Ernesto Rondon HS",
    "Eulogio Rodriguez, Jr. HS",
    "Judge Juan Luna HS",
    "Lucrecia Kasilag SHS (SHS Within E. Abada ES)",
    "Masambong HS",
    "Nick Joaquin SHS (SHS Within Toro Hills ES)",
    "Pugad Lawin HS",
    "Quezon City Science HS",
    "San Francisco High School",
    "San Jose High School",
    "Sergio Osmena, Sr. HS",
    "Bagong Silangan HS",
    "Batasan Hills National High School",
    "Commonwealth High School",
    "Holy Spirit National High School",
    "Judge Feliciano Belmonte, Sr. High School",
    "Justice Cecilia Munoz Palma High School",
    "Justice Cecilia Munoz Palma Senior High School",
    "Balara High School",
    "Camp Gen. E. Aguinaldo High School",
    "Carlos P. Garcia High School",
    "Don Quintin Paredes High School",
    "Jose P. Laurel Sr. High School",
    "Juan Sumulong High School",
    "Quirino High School",
    "Vito L. Belarmino Senior High School",
    "Camp Crame High School",
    "Carlos L. Albert High School",
    "Don Alejandro Roces, Sr. Sci. & Tech. High School",
    "Dr. Josefa Jara Martinez High School",
    "Eugenio Lopez Jr. Center for Media Arts (SHS within Kamuning ES - A&D)",
    "Fernando C. Amorsolo Senior High School",
    "Flora A. Ylagan High School",
    "Jose V. Palma Senior High School (within Pinyahan ES)",
    "Krus Na Ligas High School",
    "Manuel A. Roxas High School",
    "P. Tuason Senior High School (within P. Tuazon ES)",
    "Ponciano A. Bernardo High School",
    "Quezon City High School",
    "Ramon Magsaysay (Cubao) High School",
    "Dona Rosario High School",
    "Jose Maria Panganiban Senior High School",
    "Lagro High School",
    "Leandro Locsin Integrated School",
    "Maligaya High School",
    "North Fairview High School",
    "Novaliches High School",
    "San Bartolome High School",
    "Sta. Lucia High School",
    "Sta. Lucia Senior High School",
    "West Fairview High School",
    "Apolonio Samson National High School",
    "Culiat High School",
    "Emilio Jacinto National High School",
    "Ismael Mathay Sr. High School",
    "Melchora Aquino High School",
    "New Era High School",
    "Sauyo High School",
    "Talipapa Senior High School",
    "Tandang Sora National High School"
];

export const gradeLevel = [
    "SPED (self-contained)",
    "SPED (pre-vocational/vocational/transition)",
    "Mainstream (partial gen ed and partial SPED)",
    "Full-time General Education"
];

export const stoppingStudyReasons = [
    "Walang kakayahang pangpinansyal",
    "Walang bago o updated assessment mula sa Developmental Pediatrician",
    "Lumipat ng tahanan o nagbago ng address ngunit nasa loob pa rin ng Quezon City",
    "Inuuna muna ang pag-therapy ng bata",
    "Ayaw na ng bata mag-aral"
];

export const notStudyingReason = [
    "Walang kakayahang pangpinansyal",
    "Wala pang assessment mula sa Developmental Pediatrician",
    "Hindi pa marunong magsalita",
    "Hindi pa marunong magsulat",
    "Hindi pa kayang maupo nang matagal",
    "Hindi tinatanggap ng school ang pagpapa-enroll ng bata",
    "Inuuna muna ang pag-therapy ng bata"
];

export const educationRelatedFields = [
    "educationLevel",
    "schoolName",
    "gradeLevel",
    "lastYearOfStudy",
    "reasonForNotStudying"
];